import ArticleRoundedIcon from '@mui/icons-material/ArticleRounded'
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded'
import MoreHorizRoundedIcon from '@mui/icons-material/MoreHorizRounded'
import PushPinRoundedIcon from '@mui/icons-material/PushPinRounded'
import type { PulseReport } from '../../types/pulseReport'
import { PULSE_REPORT_KIND_LABEL } from '../../types/pulseReport'
import { formatCredits as formatCreditsShared } from '../Credits/formatCredits'
import { IconButton } from '../Common/IconButton'
import { Pressable } from '../Common/Pressable'

const relativeTime = (createdAtMs: number, now = Date.now()) => {
  const delta = Math.max(0, now - createdAtMs)
  const minutes = Math.floor(delta / 60_000)
  if (minutes < 1) return 'just now'
  if (minutes < 60) return `${minutes}m ago`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours}h ago`
  const days = Math.floor(hours / 24)
  return `${days}d ago`
}

export const PulseReportListRow = ({
  report,
  onOpen,
  onPin,
  onDelete,
}: {
  report: PulseReport
  onOpen: (report: PulseReport) => void
  onPin: (report: PulseReport) => void
  onDelete: (report: PulseReport) => void
}) => (
  <article className={`pulseReportRow pulseReportRow--${report.status.toLowerCase()}`}>
    <Pressable className="pulseReportRow__main" onClick={() => onOpen(report)}>
      <span className="pulseReportRow__icon" aria-hidden="true"><ArticleRoundedIcon fontSize="small" /></span>
      <span className="pulseReportRow__copy">
        <strong>{report.content.headline || `${PULSE_REPORT_KIND_LABEL[report.kind]} report`}</strong>
        <small>
          {PULSE_REPORT_KIND_LABEL[report.kind]} · {relativeTime(report.createdAtMs)} · {formatCreditsShared(report.creditsCharged, { suffix: 'cr' })}
        </small>
      </span>
    </Pressable>
    <div className="pulseReportRow__actions" aria-label="Report actions">
      <IconButton
        size="sm"
        variant="tertiary"
        pressed={report.pinned}
        onClick={() => onPin(report)}
        label={report.pinned ? 'Unpin report' : 'Pin report'}
        icon={<PushPinRoundedIcon fontSize="inherit" />}
      />
      <IconButton
        size="sm"
        variant="tertiary"
        tone="danger"
        onClick={() => onDelete(report)}
        label="Delete report"
        icon={<DeleteOutlineRoundedIcon fontSize="inherit" />}
      />
      <span aria-hidden="true"><MoreHorizRoundedIcon fontSize="inherit" /></span>
    </div>
  </article>
)
